import React, { useEffect } from "react";
import { BrowserRouter, Route, Switch } from "react-router-dom";
import "./scss/style.scss";
import ReceivedOrder from "views/orderConfirm/ReceivedOrder";
import IssueOrder from "views/orderConfirm/IssueOrder";
import ConfirmOrder from "views/orderConfirm/ConfirmOrder";
import { connectWebSocket } from "services/websocket";

const loading = (
  <div className="pt-3 text-center">
    <div className="sk-spinner sk-spinner-pulse"></div>
  </div>
);

const TheLayout = React.lazy(() => import("./containers/TheLayout"));

const Login = React.lazy(() => import("./views/auth/Login"));
const Register = React.lazy(() => import("./views/auth/Register/Register"));
const ForgotPassword = React.lazy(
  () => import("./views/auth/ForgotPassword/ForgotPassword"),
);
// const Caresoft = React.lazy(() => import("./views/caresoft/CsView"));

const App = (props) => {
  useEffect(() => {
    const token = localStorage.getItem("NTXAuthenticate");

    if (token) {
      connectWebSocket(token);
    }
  }, []);
  return (
    <BrowserRouter>
      <React.Suspense fallback={loading}>
        <Switch>
          <Route
            exact
            path="/login"
            name="Login Page"
            render={(props) => <Login {...props} />}
          />
          <Route
            path="/register"
            name="Register Page"
            render={(props) => <Register {...props} />}
          />
          {/* <Route
            path="/order-received-confirm/:id"
            name="Order Confirm"
            render={(props) => <ReceivedOrder {...props} />}
          /> */}
          {/* <Route
            path="/order-issue-confirm/:id"
            name="Order Issue Confirm"
            render={(props) => <IssueOrder {...props} />}
          /> */}
          {/* <Route
            path="/order-confirm-info/:id"
            name="Order Select"
            render={(props) => <ConfirmOrder {...props} />}
          /> */}
          <Route
            path="/forgot-password"
            name="Forgot Password Page"
            render={(props) => <ForgotPassword {...props} />}
          />
          {/* <Route
            path="/caresoft-staging"
            name="Caresoft"
            render={(props) => <Caresoft {...props} />}
          /> */}
          <Route
            path="/"
            name="Home"
            render={(props) => <TheLayout {...props} />}
          />
        </Switch>
      </React.Suspense>
    </BrowserRouter>
  );
};

export default App;
